import axios from "axios";
import Toastify from "toastify-js";
import "toastify-js/src/toastify.css";

export default function registroForm() {

  const form = document.querySelector("#formulario_contact_ny");
  if (!form) return;

  const btnSubmit = form.querySelector("button[type=submit]");

  // ===============================
  // SUBMIT
  // ===============================
  form.addEventListener("submit", async function (event) {

    event.preventDefault();
    disabledBtn();

    const nome = form.querySelector("input[name=nome]")?.value?.trim() || "";
    const email = form.querySelector("input[name=email]")?.value?.trim() || "";
    const programaValue = form.querySelector("input[name=programa]")?.value || "";
    const mensagem = form.querySelector("textarea[name=mensagem]")?.value?.trim() || "";

    // Converte para número (ID)
    const programa = Number(programaValue) || "";

    // ===============================
    // VALIDAÇÕES
    // ===============================
    if (!nome) {
      showMessage("Informe seu nome.", true);
      enabledBtn();
      return;
    }

    if (!email) {
      showMessage("Informe seu e-mail.", true);
      enabledBtn();
      return;
    }

    if (!programa) {
      showMessage("Selecione um programa válido.", true);
      enabledBtn();
      return;
    }

    if (!mensagem) {
      showMessage("Digite uma mensagem.", true);
      enabledBtn();
      return;
    }

    // ===============================
    // PAYLOAD
    // ===============================
    const formData = {
      nome,
      email,
      programa, // ID
      mensagem,
    };

    const url = "/form-registro-ny/";

    // ===============================
    // REQUEST
    // ===============================
    try {

      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "application/json",
          "X-CSRFToken": getCookie("csrftoken"),
        },
      });

      showMessage(response?.data?.message || "Enviado com sucesso!");
      form.reset();

      // Limpa label do select
      resetProgramSelect();

    } catch (error) {

      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Erro ao enviar a mensagem";

      showMessage(msg, true);

    } finally {

      setTimeout(enabledBtn, 600);

    }

  });

  // ===============================
  // TOAST
  // ===============================
  function showMessage(message, isError = false) {

    Toastify({
      text: message,
      duration: 3500,
      newWindow: true,
      close: true,
      gravity: "top",
      position: "center",
      stopOnFocus: true,
      style: {
        background: isError
          ? "linear-gradient(to right, #b00020, #ff4d4d)"
          : "linear-gradient(to right, #00b09b, #96c93d)",
      },
    }).showToast();

  }

  // ===============================
  // BUTTON CONTROL
  // ===============================
  function disabledBtn() {

    if (!btnSubmit) return;

    btnSubmit.disabled = true;
    btnSubmit.classList.add("disabled");

  }

  function enabledBtn() {

    if (!btnSubmit) return;

    btnSubmit.disabled = false;
    btnSubmit.classList.remove("disabled");

  }

  // ===============================
  // RESET SELECT
  // ===============================
  function resetProgramSelect() {

    const input = form.querySelector(".program-value");
    const label = form.querySelector(".program-label");

    if (input) input.value = "";

    if (label) {
      label.textContent = "Select a program";
      label.classList.remove("text-white");
      label.classList.add("text-white/40");
    }

  }

  // ===============================
  // CSRF
  // ===============================
  function getCookie(name) {

    let cookieValue = null;

    if (document.cookie && document.cookie !== "") {

      const cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; i++) {

        const cookie = cookies[i].trim();

        if (cookie.startsWith(name + "=")) {

          cookieValue = decodeURIComponent(
            cookie.substring(name.length + 1)
          );

          break;

        }

      }

    }

    return cookieValue;

  }

}
